import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Alert, Button } from "@mui/material";
import { Warning } from "@mui/icons-material";
import { fetchSubscription } from "../../redux/slices/billingSlice";

/**
 * PastDueBanner — shows a warning when the org subscription is past_due.
 * Place in the DashboardLayout so it appears on all dashboard pages.
 */
export default function PastDueBanner() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { subscription } = useSelector((state) => state.billing);

  useEffect(() => {
    dispatch(fetchSubscription());
  }, [dispatch]);

  if (!subscription) return null;

  const status = subscription.status;

  if (status === "PAST_DUE" || status === "UNPAID") {
    return (
      <Alert
        severity="error"
        icon={<Warning />}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={() => navigate("/dashboard/billing")}
          >
            Update Payment
          </Button>
        }
        sx={{ borderRadius: 0 }}
      >
        Your payment is overdue. Please update your payment method to avoid
        service disruption.
      </Alert>
    );
  }

  if (subscription.cancelAtPeriodEnd) {
    const endDate = subscription.currentPeriodEnd
      ? new Date(subscription.currentPeriodEnd).toLocaleDateString()
      : "the end of your billing period";

    return (
      <Alert
        severity="warning"
        action={
          <Button
            color="inherit"
            size="small"
            onClick={() => navigate("/dashboard/billing")}
          >
            Manage Subscription
          </Button>
        }
        sx={{ borderRadius: 0 }}
      >
        Your subscription is scheduled to cancel on {endDate}.
      </Alert>
    );
  }

  return null;
}
